import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { VolumeX } from 'lucide-mui';

const NoAudio: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100vh"
      textAlign="center"
    >
      <VolumeX sx={{ fontSize: 45, color: 'secondary.main' }} />
      <Typography
        variant="h5"
        fontWeight={500}
        color="secondary.contrastText"
        mt={2}
      >
        No audio detected in this recording.
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClickOpen}
        sx={{ mt: 2 }}
      >
        Learn more
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ fontWeight: 600 }}>
          Why is there no audio?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            This recording does not have an audio track. Possible reasons
            include:
          </Typography>
          <Typography variant="body2" component="ul" sx={{ mt: 1 }}>
            <li>Audio permissions were not granted by the browser.</li>
            <li>The wrong microphone was selected.</li>
            <li>No microphone is connected to the recording device.</li>
            <li>There was a technical issue during recording.</li>
            <li>The audio input was muted or set too low.</li>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NoAudio;
